import { useEffect } from 'react'
import { Input } from '../../../../common/html/input'
import { Loading } from '../../../../common/loading'
import { isInValidValue } from '../../../../helpers/value'
import classes from '../../../index.module.scss'
import {
  checkEmailValid,
  checkInvalidInputVal,
  checkPhoneValid,
} from '../helper'
import { ALL_QUOTATION_FIELDS, QUOTATION_FIELD_KEYS } from './constants'

export const QuotationForm = ({
  form,
  setForm,
  isValid,
  setIsValid,
  userProfile,
  loadingUserProfle,
}) => {
  const getTextInvalid = (key) => {
    let textInvalid = ''
    if (key === QUOTATION_FIELD_KEYS.PHONE) {
      textInvalid = 'domesticSearchPreview.INVALID_PHONE'
    }

    if (key === QUOTATION_FIELD_KEYS.EMAIL) {
      textInvalid = 'domesticSearchPreview.INVALID_EMAIL'
    }

    return typeof form[key] === 'string' && !!form[key].trim()
      ? textInvalid
      : 'userProfile.REQUIRED_FIELD'
  }

  const onChange = (key, event, isRequiredField) => {
    const eventValue = event.target.value

    if (isRequiredField) {
      setIsValid({
        ...isValid,
        [key]: !checkInvalidInputVal(eventValue),
      })
    }

    if (key === QUOTATION_FIELD_KEYS.EMAIL) {
      setIsValid({
        ...isValid,
        [key]: checkEmailValid(eventValue),
      })
    }

    if (key === QUOTATION_FIELD_KEYS.PHONE) {
      let value = ''
      const regex = /^\+?[0-9]*$/g

      if (!eventValue || eventValue.match(regex)) {
        value = eventValue
      }

      if (!eventValue.match(regex)) {
        value = form[QUOTATION_FIELD_KEYS.PHONE] || ''
      }

      setIsValid({
        ...isValid,
        [key]: checkPhoneValid(value),
      })
      setForm({ ...form, [key]: value })
    } else {
      setForm({ ...form, [key]: eventValue })
    }
  }

  useEffect(() => {
    let defaultForm = {}
    if (userProfile) {
      const allFieldFilled = Object.values(QUOTATION_FIELD_KEYS).map((item) => {
        return {
          [item]: userProfile[item] || '',
          taxCode: userProfile?.companyTaxCode ?? '',
          clientName: userProfile?.fullName || '',
          clientTitle: userProfile?.jobTitle || '',
        }
      })
      defaultForm = Object.assign({}, ...allFieldFilled)
    }
    setForm(defaultForm)
  }, [userProfile])

  return loadingUserProfle ? (
    <Loading />
  ) : (
    <div className={[classes.content, 'flexColumn'].join(' ')}>
      {ALL_QUOTATION_FIELDS.map((item) => (
        <Input
          isShowIcon={false}
          placeHolder={item.title}
          containerStyle={
            !!isValid[item.key] || isInValidValue(isValid[item.key])
              ? { marginBottom: 20 }
              : { marginBottom: 30 }
          }
          isShowLabel
          key={item.key}
          isValid={isValid[item.key]}
          textInvalid={getTextInvalid(item.key)}
          onChange={(e) => onChange(item.key, e, true)}
          value={form[item.key]}
        />
      ))}
    </div>
  )
}
